import { AutoMap } from "@automapper/classes";
import { CassetteDTO } from "./cassette.dto";
import { TaskDTO } from "./task.dto";


export class OperatorDTO {
    @AutoMap()
    position!: number;
    @AutoMap()
    firstName!: string;
    @AutoMap()
    lastName!: string;
    @AutoMap(() => [CassetteDTO])
    cassetteList: CassetteDTO[] = [];
    @AutoMap(() => [TaskDTO])
    taskList: TaskDTO[] = [];

}